<template>
  <div v-if="establishmentRolesData" class="">
    <div class="table-container">
      <table class="my-table">
        <thead>
          <tr>
            <th>#</th>
            <th>{{ $t("name") }}</th>
            <th>{{ $t("description") }}</th>
            <th>{{ $t("info") }}</th>
            <th>{{ $t("edit") }}</th>
            <th>{{ $t("delete") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(role, index) in establishmentRolesData" :key="index">
            <td>{{ ++index }}</td>
            <td>
              {{ isDataExist(role.establishmentRoleNameCurrent) }}
            </td>
            <td>
              {{ isDataExist(role.establishmentRoleDescriptionCurrent) }}
            </td>
            <td>
              <button
                v-b-modal.EstablishmentRoleInfo
                class="btn p-0"
                :title="$t('info')"
                @click="setEstablishmentRoleData(role)"
              >
                <img src="@/assets/images/info.svg" class="icon-lg" />
              </button>
            </td>
            <td>
              <router-link
                :to="`/edit-establishment-role/${role.establishmentRoleToken}`"
                :title="$t('edit')"
              >
                <img src="@/assets/images/pencil.svg" class="icon-lg" />
              </router-link>
            </td>
            <td>
              <button
                v-b-modal.EstablishmentRoleDelete
                class="btn p-0"
                :title="$t('delete')"
                @click="setEstablishmentRoleData(role)"
              >
                <img src="@/assets/images/trash.svg" class="icon-lg" />
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { setDataMultiLang, timeToLang, isDataExist } from "@/utils/functions";

export default {
  name: "CountriesTable",
  data() {
    return {
      language: localStorage.getItem("userLanguage") || "ar",
    };
  },
  props: ["establishmentRolesData", "establishmentRoleData"],
  methods: {
    setEstablishmentRoleData(establishmentRoleData) {
      this.$emit("setEstablishmentRoleData", establishmentRoleData);
    },
    timeToLang(time) {
      return timeToLang(time, this.language);
    },
    setDataMultiLang(lang, dataAr, dataEn, dataUnd) {
      return setDataMultiLang(lang, dataAr, dataEn, dataUnd);
    },
    isDataExist(data) {
      return isDataExist(data);
    },
  },
  computed: {},
};
</script>

<style lang="scss"></style>
